var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as funs from "../../utils";
import * as newFns from "./functions";
import { kakaoShare } from "./module/kakaoShare";
import { youtubeVideoInfoInit, getYoutubeVideoInfo } from "./module/youtubeApi";
import { mergeParams, mergeHashParams, parseHash, } from "./module/urlQueryAndHash";
export var gameUtils = __assign(__assign(__assign({}, funs), newFns), { mergeParams: mergeParams, mergeHashParams: mergeHashParams, parseHash: parseHash, youtubeVideoInfoInit: youtubeVideoInfoInit, getYoutubeVideoInfo: getYoutubeVideoInfo, kakaoShare: kakaoShare });
//# sourceMappingURL=index.js.map